import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import styled from 'styled-components'
import get from 'lodash/get'
import Helmet from 'react-helmet'
import ReactList from 'react-list'
import Waypoint from 'react-waypoint'
import { Merge } from 'animate-components'
import { fadeIn, slideUp } from 'animate-keyframes'
import Title from '../components/title'
import Description from '../components/description'
import ScrollUp from '../components/scroll-up'
import About from '../components/about'
import { First, Second, Third } from '../components/preview'
const R = require('ramda')

class BlogIndex extends React.Component {
  state = { items: []}

  doAnimation = (index) => {
    this.setState({ items: this.state.items.concat(index) })
  }

  renderItem = (index, key) => {
    const posts = get(this, 'props.data.allMarkdownRemark.edges')

    function getRandomInt(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    }

    const duration = getRandomInt(3, 4) + 's'
    const fadeInDuration = '3s'

    if (
      index === 0 ||
      index === 3 ||
      index === 6 ||
      index === 9 ||
      index === 12 ||
      index === 15 ||
      index === 18 ||
      index === 21 ||
      index === 24 ||
      index === 27 ||
      index === 30 ||
      index === 33
    ) {

      return (
        <Merge
          key={key}
          one={{ name: fadeIn, duration: fadeInDuration, }}
          two={{ name: slideUp, duration: duration, }}
        >
          <Waypoint
            topOffset="50%"
            onEnter={(index) => this.doAnimation(index)}
          />
          <First
            doAnimation={this.state.items[index]}
            linkTo={posts[index].node.frontmatter.path}
            thumb={posts[index].node.frontmatter.thumb.childImageSharp.sizes}
            title={posts[index].node.frontmatter.title}
            description={posts[index].node.frontmatter.description}
          />
        </Merge>
      )
    }

    if (
      index === 1 ||
      index === 4 ||
      index === 7 ||
      index === 10 ||
      index === 13 ||
      index === 16 ||
      index === 19 ||
      index === 22 ||
      index === 25 ||
      index === 28 ||
      index === 31 ||
      index === 34
    ) {
      return (
        <Merge
          key={key}
          one={{ name: fadeIn, duration: fadeInDuration, }}
          two={{ name: slideUp, duration: duration, }}
        >
          <Waypoint
            topOffset="50%"
            onEnter={(index) => this.doAnimation(index)}
          />
          <Second
            duration={duration}
            linkTo={posts[index].node.frontmatter.path}
            thumb={posts[index].node.frontmatter.thumb.childImageSharp.sizes}
            title={posts[index].node.frontmatter.title}
            description={posts[index].node.frontmatter.description}
          />
        </Merge>
      )
    }

    if (
      index === 2 ||
      index === 5 ||
      index === 8 ||
      index === 11 ||
      index === 14 ||
      index === 17 ||
      index === 20 ||
      index === 23 ||
      index === 26 ||
      index === 29 ||
      index === 32 ||
      index === 35
    ) {
      return (
        <Merge
          key={key}
          one={{ name: fadeIn, duration: fadeInDuration, }}
          two={{ name: slideUp, duration: duration, }}
        >
          <Waypoint
            topOffset="50%"
            onEnter={(index) => this.doAnimation(index)}
          />
          <Third
            doAnimation={this.state.items[index]}
            linkTo={posts[index].node.frontmatter.path}
            thumb={posts[index].node.frontmatter.thumb.childImageSharp.sizes}
            title={posts[index].node.frontmatter.title}
            description={posts[index].node.frontmatter.description}
          />
        </Merge>
      )
    }
  }

  render() {
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const posts = get(this, 'props.data.allMarkdownRemark.edges')

    return (
      <div>
        <Helmet title={get(this, 'props.data.site.siteMetadata.title')} />
        <About />
        <ReactList
          threshold={500}
          pageSize={1}
          itemRenderer={this.renderItem}
          itemsRenderer={(posts, ref) => (
            <div
              ref={ref}
              style={{
                display: "flex",
                flexWrap: "wrap",
                paddingBottom: "50vh",
              }}
            >
              {posts}
            </div>
          )}
          length={posts.length}
          type="simple"
        />
        <ScrollUp title="Back to top" />
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex

export const homepageQuery = graphql`
  query homepageQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
      edges {
        node {
          excerpt
          frontmatter {
            path
            date(formatString: "DD MMMM, YYYY")
            title
            description
            thumb {
              childImageSharp {
                sizes(maxWidth: 900, maxHeight: 900, cropFocus: CENTER) {
                  ...GatsbyImageSharpSizes
                }
              }
            }
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js